import request from '@/utils/request' //引入封装好的 axios 请求

export function updateNewsContent(newsId, newsTitle, newsIntroduction,photo,createTime,updateTime,newsContent) {
  return request({
    url: '/news/updateNewsContent',
    method: 'post',
    data: {
      newsId,
      newsContent,
      newsTitle,
      newsIntroduction,
      photo,
      createTime,
      updateTime
    }

  })
}

export function updateNewsInfo(newsId,newsTitle, newsIntroduction,photo,updateTime) {
  return request({
    url: '/news/updateNewsInfo',
    method: 'post',
    data: {
      newsId,
      newsTitle,
      newsIntroduction,
      photo,
      updateTime
    }

  })
}

export function updateNewsReleaseKbn(newsId,releaseKbn,updateTime) {
  return request({
    url: '/news/updateNewsReleaseKbn',
    method: 'post',
    data: {
      newsId,
      releaseKbn,
      updateTime
    }

  })
}

export function updateHot(newsId,hot) {
  return request({
    url: '/news/updateHot',
    method: 'post',
    data: {
      newsId,
      hot
    }
  })
}